module.exports = __webpack_public_path__ + "static/img/Matrix_Games_Banner.0c0c988.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Matrix_Games_Banner.png
// module id = RK1P
// module chunks = 8